module.exports = __webpack_public_path__ + "img/sam.cd6baad.webp";